import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';
import { concat, isEmpty, isNil } from 'lodash';

import * as mapOps from '../../../api/Maps/map-operations';
import Maps from '../../../api/Maps/Maps';
import Layers from '../../../api/Layers/Layers';

import Loading from '../../components/Loading';
import NotFound from '../NotFound';
import NewLayout from '../../containers/MapContainerMA';
import useTimeStore from '../../components/ZustandProvider';
import LoadingComponent from '../../components/LoadingComponent';
import LoadingIpsilum from '../../components/LoadingIpsilum';

const { isBeta } = Meteor.settings.public;
const AdvancedMap = props => {
  const {
    loading,
    map,
    name,
    emailAddress,
    match,
    layers,
    deployEnv,
    history,
    isFullScreen,
    isAtlas,
    userControlSetting,
    userId,
    roles
  } = props;
  const [isLoadingIpsilum, setIsLoadingIpsilum] = React.useState(false);
  if (loading) return <Loading />;
  if (isEmpty(map)) return <NotFound />;
  const baseMapsList = mapOps.getLayerObjectsArray(map, layers, false);
  const baseMapDefault =
    userControlSetting.defaultBaseMap && !isEmpty(userControlSetting.defaultBaseMap)
      ? layers.find(layer => layer._id === userControlSetting.defaultBaseMap)
      : '';
  const baseMaps = isEmpty(baseMapsList) ? [baseMapDefault] : baseMapsList;
  const MapProps = {
    baseMaps,
    deployEnv,
    history,
    isAtlas,
    isFullScreen,
    layers: mapOps.getLayerObjectsArray(map, layers),
    match,
    map,
    userControlSetting
  };
  const createUserLocalId = () => {
    let userIpsilum = JSON.parse(localStorage.getItem('userIpsilum'));
    if (!userIpsilum || !userIpsilum.id) {
      const newId = Array.from({ length: 18 }, () => Math.random().toString(36)[2]).join('');
      userIpsilum = {
        id: newId,
        name: 'userIpsilum'
      };
      localStorage.setItem('userIpsilum', JSON.stringify(userIpsilum));
    }
    return userIpsilum;
  };

  const userProps = {
    userId,
    roles,
    name,
    emailAddress,
    userLocalId: createUserLocalId()
  };
  const changeLoading = time => {
    setIsLoadingIpsilum(true);
    setTimeout(() => {
      setIsLoadingIpsilum(false);
    }, time);
  };
  return (
    <Row className={isAtlas ? 'h-100 mx-0' : ''}>
      <Col xs={12} className={isAtlas ? 'h-100 px-0' : ' px-0'}>
        <>
          {!isBeta && <LoadingComponent adjustMapProp />}
          {isLoadingIpsilum && <LoadingIpsilum />}
          <NewLayout
            MapProps={MapProps}
            userProps={userProps}
            isPublicMap={false}
            changeLoading={changeLoading}
          />
        </>
      </Col>
    </Row>
  );
};

AdvancedMap.defaultProps = {
  emailAddress: '',
  history: {},
  isAtlas: false,
  layers: [],
  loading: true,
  map: {},
  match: {},
  name: '',
  userControlSetting: {},
  userId: '',
  roles: []
};

AdvancedMap.propTypes = {
  deployEnv: PropTypes.string.isRequired,
  emailAddress: PropTypes.string,
  history: PropTypes.object,
  isAtlas: PropTypes.bool,
  isFullScreen: PropTypes.bool.isRequired,
  layers: PropTypes.array,
  loading: PropTypes.bool,
  map: PropTypes.object,
  match: PropTypes.object,
  name: PropTypes.string,
  roles: PropTypes.array,
  userControlSetting: PropTypes.object,
  userId: PropTypes.string
};

export default withTracker(({ match }) => {
  const mapPublicId = match.params.map_id;
  const { variable } = match.params;
  // abc=foo&def=[asf]&xyz=5&foo=b%3Dar

  const mapSub = Meteor.isClient && Meteor.subscribe('maps.view', mapPublicId);
  const map = Maps.findOne({ _id: mapPublicId });

  if (!isEmpty(variable)) {
    const parameters = JSON.parse(
      `{"${variable.replace(/&/g, '","').replace(/=/g, '":"')}"}`,
      (key, value) => {
        return key === '' ? value : decodeURIComponent(value);
      }
    );
    const longlat = [Number(parameters.lng), Number(parameters.lat)];
    // eslint-disable-next-line no-restricted-globals
    if (!isEmpty(map) && !longlat.some(isNaN)) {
      map.mapLocation.geometry.coordinates = longlat;
      const zoom = isEmpty(parameters.zoom) ? 15 : Number(parameters.zoom);
      map.mapLocation.properties.zoom = zoom;
    }
  }

  let layerIds = [];
  if (!isNil(map)) {
    layerIds = concat(mapOps.getLayers(map), mapOps.getBaseMaps(map));
  }
  const layersSub = Meteor.isClient && Meteor.subscribe('layers.viewPublicMap', layerIds);
  const sizeDrawerSelected = map ? map.settingsAdvancedMap.sizeDrawer.value : 0;
  useTimeStore.setState({ drawerWidth: sizeDrawerSelected });

  return {
    loading: !Meteor.isClient || !mapSub.ready() || !layersSub.ready(),
    map,
    layers: Layers.find({ _id: { $in: layerIds }, deleted: { $eq: 'no' } }).fetch()
  };
})(AdvancedMap);
